import { Theme } from '@emotion/react';
import { Button, Divider, SxProps, Grid } from '@mui/material';
import React from 'react';
import { WsColors } from 'wisestep-base';

export interface Action {
  id: string;
  label: string;
  icon?: React.ReactElement;
  variant: 'text' | 'outlined' | 'contained';
  show: boolean;
  onClick: () => void;
  sx?: SxProps<Theme>;
}

export interface ActionsBarProps {
  actions: Action[];
}

const ActionsBar = ({ actions }: ActionsBarProps) => {
  const visibleActions = actions.filter((action) => action.show);
  return (
    <Grid display="flex" alignItems="center">
      {visibleActions.map((action, idx) => (
        <React.Fragment key={action.id}>
          <Button
            variant={action.variant}
            startIcon={action.icon}
            onClick={action.onClick}
            sx={{ fontWeight: 700, fontSize: 14, ...action.sx }}
          >
            {action.label}
          </Button>
          {idx !== visibleActions.length - 1 && (
            <Divider orientation="vertical" sx={{ mx: 1.5, bgcolor: WsColors.white_shadow }} />
          )}
        </React.Fragment>
      ))}
    </Grid>
  );
};

export default ActionsBar;
